import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  BottomNavigation,
  BottomNavigationAction,
  Divider,
  Paper
} from '@mui/material'

import HomeIcon from '@mui/icons-material/Home'
import DoorBackOutlinedIcon from '@mui/icons-material/DoorBackOutlined'

import AssignmentIcon from '@mui/icons-material/Assignment'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'

import WorkIcon from '@mui/icons-material/Work'
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined'

import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined'

import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

export default function BottomNavBar () {
  const navigate = useNavigate()
  const location = useLocation()
  const [value, setValue] = useState(0)
  const [anchorEl, setAnchorEl] = useState(null) // For Jobs menu

  // Handle Jobs menu open
  const handleJobsMenuOpen = event => {
    setAnchorEl(event.currentTarget)
  }

  // Handle Jobs menu close
  const handleJobsMenuClose = () => {
    setAnchorEl(null)
  }

  // Handle navigation for Jobs menu items
  const handleJobsMenuItemClick = nav => {
    navigate(nav)
    handleJobsMenuClose()
  }

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        height: '4rem'
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue)
        }}
        style={{ display: 'flex', alignItems: 'center', height: '100%' }}
      >
        {/* {location.pathname === '/recruiter/newsearch' && (
          <>
            <BottomNavigationAction
              label='Filter'
              icon={<FilterListIcon />}
              onClick={() => alert('Filter button clicked')}
              style={{ minWidth: '0px' }}
            />
            <Divider orientation='vertical' style={{ height: '50%' }} />
          </>
        )} */}

        <BottomNavigationAction
          label='Home'
          icon={<DoorBackOutlinedIcon />}
          onClick={() => navigate('/recruiter/dashboard')}
          style={{ minWidth: '0px' }}
        />

        <BottomNavigationAction
          label='Apply'
          icon={<AssignmentOutlinedIcon />}
          onClick={() => navigate('/recruiter/trackcandidate')}
          style={{ minWidth: '0px' }}
        />

        <BottomNavigationAction
          label='Jobs'
          icon={<WorkOutlineOutlinedIcon />}
          onClick={handleJobsMenuOpen}
          style={{ minWidth: '0px' }}
        />

        <BottomNavigationAction
          label='Earnings'
          icon={<CurrencyRupeeOutlinedIcon />}
          onClick={() => navigate('/recruiter/referralearning')}
          style={{ minWidth: '0px' }}
        />
      </BottomNavigation>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleJobsMenuClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              width: 230,
              overflow: 'hidden',
              maxHeight: '80vh',
              overflowY: 'auto',
              filter: 'drop-shadow(0px 4px 8px rgba(0,0,0,0.1))',
              right: '16px',
              borderRadius: '0px',
              transform: 'translateY(-50px) !important',
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 0
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0
              }
            }
          }
        }}
      >
        <MenuItem
          onClick={() => handleJobsMenuItemClick('/recruiter/newsearch')}
        >
          Search Job
        </MenuItem>
        <MenuItem
          onClick={() => handleJobsMenuItemClick('/recruiter/worklist')}
        >
          Jobs in Your Worklists
        </MenuItem>
        <MenuItem
          onClick={() => handleJobsMenuItemClick('/recruiter/workedon')}
        >
          Assignments You Handled
        </MenuItem>
      </Menu>
    </Paper>
  )
}
